import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { MdStar } from "react-icons/md";
import "./ReviewCard.css";

const ReviewCard = ({ review }) => {
  const { customerName, customerImg, message, ratings } = review;

  return (
    <div className="col">
      <div className="card rounded-3 card-log review-card mx-auto">
        <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center px-2">
          <div className="d-flex justify-content-center align-items-center ms-2 me-3 mt-3 mt-lg-0">
            <PhotoProvider
              speed={() => 800}
              easing={(type) =>
                type === 2
                  ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                  : "cubic-bezier(0.34, 1.56, 0.64, 1)"
              }
            >
              <PhotoView src={customerImg}>
                <LazyLoadImage
                  src={customerImg}
                  alt={customerName}
                  className="rounded-pill rounded-lg-3 card-log"
                  placeholderSrc={customerImg}
                  effect="blur"
                  width="85px"
                  height="85px"
                  title={customerName}
                  style={{ objectFit: "cover", cursor: "pointer" }}
                />
              </PhotoView>
            </PhotoProvider>
          </div>

          <div className="card-body mt-1 mt-lg-0 px-2 px-lg-3">
            <p className="card-title mb-1">
              <b>Name:</b> {customerName}
            </p>
            <p className="card-text mb-0">
              <b>Rating:</b>
              <span className="fw-semibold ms-1">
                {ratings}
                <span>
                  <MdStar className="orange-color fs-5 mb-1" />
                </span>
              </span>
            </p>
            <p className="card-text mb-1">
              <b className="me-1">Review:</b>
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
